document.addEventListener('click', function (e) {
  const link = e.target.closest('[data-ajax-product-link]');
  if (!link) return;

  e.preventDefault();
  loadProductAjax(link.href);
});

window.addEventListener('popstate', function (e) {
  if (e.state && e.state.ajaxProduct) {
    loadProductAjax(e.state.ajaxProduct, false);
  }
});

function loadProductAjax(url, pushState = true) {
  const container = document.querySelector('product-info[id^="MainProduct-"]');
  if (!container) return;

  container.classList.add('na-loading');

  fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      const newSection = newDoc.querySelector('product-info[id^="MainProduct-"]');

      if (!newSection) {
        window.location.href = url;
        return;
      }

      container.replaceWith(newSection);

      if (pushState) {
        history.pushState({ ajaxProduct: url }, '', url);
      }

      if (newDoc.title) {
        document.title = newDoc.title;
      }

      newSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })
    .catch((err) => {
      console.error('AJAX product load failed:', err);
      window.location.href = url;
    })
    .finally(() => {
      // container reference is stale after replaceWith, so target the new one
      const current = document.querySelector('product-info[id^="MainProduct-"]');
      if (current) current.classList.remove('na-loading');
    });
}


document.addEventListener('DOMContentLoaded', initCollectionSliders);
document.addEventListener('click', function (e) {
  const prevBtn = e.target.closest('.na-collection-arrow--prev');
  const nextBtn = e.target.closest('.na-collection-arrow--next');
  if (!prevBtn && !nextBtn) return;

  const wrapper = (prevBtn || nextBtn).closest('.na-collections-wraps');
  const track = wrapper && wrapper.querySelector('[data-na-slider]');
  if (!track) return;

  const scrollAmount = track.clientWidth * 0.8;
  track.scrollBy({
    left: prevBtn ? -scrollAmount : scrollAmount,
    behavior: 'smooth'
  });
});

function initCollectionSliders() {
  document.querySelectorAll('.na-collections-wraps').forEach(function (wrapper) {
    const track = wrapper.querySelector('[data-na-slider]');
    const prevBtn = wrapper.querySelector('.na-collection-arrow--prev');
    const nextBtn = wrapper.querySelector('.na-collection-arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrowState() {
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    track.addEventListener('scroll', updateArrowState);
    updateArrowState();
  });
}